import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { fetchEventPosts, type BlogPost } from "../services/bloggerApi";
import BlogPostComponent from "../components/BlogPost";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
};

const Events = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  // const [nextPageToken, setNextPageToken] = useState<string | undefined>();

  const loadPosts = async (pageToken?: string) => {
    try {
      setLoading(true);
      const data = await fetchEventPosts(pageToken);
      if (pageToken) {
        setPosts((prev) => [...prev, ...data.items]);
      } else {
        setPosts(data.items);
      }
      // setNextPageToken(data.nextPageToken);
    } catch (err) {
      setError(
        "Etkinlikler yüklenirken bir hata oluştu. Lütfen tekrar deneyin.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPosts();
  }, []);

  return (
    <main className="min-h-screen bg-gradient-to-b from-[#0A0A0A] via-[#111111] to-[#0A0A0A]">
      <div className="absolute inset-0 bg-[url('/noise.png')] opacity-5 pointer-events-none"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="pt-32 pb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h1 className="text-[40px] font-bold text-white mb-4">
              Etkinliklerimiz
            </h1>
            <p className="text-xl text-gray-400">
              Kolektif Oluşum'un düzenlediği etkinlikler ve organizasyonlar
            </p>
          </motion.div>

          {error ? (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="max-w-3xl mx-auto text-center p-6 rounded-xl bg-red-500/10 backdrop-blur-sm border border-red-500/20"
            >
              <p className="text-red-400">{error}</p>
            </motion.div>
          ) : (
            <motion.div
              variants={container}
              initial="hidden"
              animate="show"
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
            >
              {posts.map((post) => (
                <motion.div key={post.id} variants={item}>
                  <BlogPostComponent post={post} variant="event" />
                </motion.div>
              ))}
            </motion.div>
          )}

          {loading && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="flex justify-center mt-12"
            >
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-400"></div>
            </motion.div>
          )}

          {/* {nextPageToken && !loading && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="flex justify-center mt-12"
            >
              <motion.button
                onClick={() => loadPosts(nextPageToken)}
                whileHover={{
                  scale: 1.02,
                  backgroundColor: "rgba(59, 130, 246, 0.2)",
                }}
                whileTap={{ scale: 0.98 }}
                className="px-8 py-4 rounded-xl bg-blue-500/10 border border-blue-500/20 text-blue-400 hover:border-blue-500/30 transition-colors"
              >
                Daha Fazla Göster
              </motion.button>
            </motion.div>
          )} */}
        </div>
      </div>
    </main>
  );
};

export default Events;
